/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    strong: "strong",
    ul: "ul",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, React.createElement(_components.strong, null, "Choosing the color"), " of the icon can be done by tapping the “choose color” or “match theme” options below the Timpage icon. Match theme will apply your theme color or can choose a different color with “choose color”."), "\n", React.createElement(_components.p, null, "Timepage’s ", React.createElement(_components.strong, null, "badge"), " can be removed completely, but is also capable of serving as a representation of the number of events remaining for the day or the date. To select either of these options, tap your choice below the “Badge” header."), "\n", React.createElement("h4", {
    className: "searchignore"
  }, "Related:"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "/support/timepage/preferences/sounds/"
  }, "Sounds")), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "/support/timepage/interface-customization/themes/"
  }, "Themes")), "\n"), "\n", React.createElement(_components.li, null, "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "/support/timepage/interface-customization/day-shading/"
  }, "Day Shading")), "\n"), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
